import { useState, useRef, useEffect } from "react";
// import "./styles.css";
import { Control, Controller, FieldError } from "react-hook-form";
import TextArea from "antd/es/input/TextArea";
import gsap from "gsap";

interface TextAreaProps {
  control: Control<any>;
  error?: FieldError | undefined;
  label?: string;
  rules?: {
    required?: any;
    [key: string]: any;
  };
  placeholder?: string;
  className?: string;
  id?: string;
  name?: string;
  value?: string;
  defaultValue?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  expandOnInput?: boolean;
}

function TextAreaComponent({
  label,
  placeholder = "",
  className = "rounded-xl",
  id,
  name = '',
  rules,
  control,
  value,
  onChange,
  error,
  rows = 1,
  defaultValue,
  expandOnInput=false,
  ...rest
}: TextAreaProps) {
  const [isExpanded, setIsExpanded] = useState(expandOnInput);
  return (
    <>
      {label && (
        <span className="mb-1 text-sm font-medium text-gray-700">
          {label}
        </span>
      )}
      <Controller
        name={name}
        rules={rules}
        control={control}
        render={({ field, fieldState: { error: fieldError } }) => (
          <TextArea
            {...field}
            name={name}
            onFocus={() => setIsExpanded(true)}
            onBlurCapture={() => setIsExpanded(false)}
            autoSize={{ minRows: rows, maxRows: isExpanded ? 50 : rows }}
            defaultValue={defaultValue}
            className={`p-2.5 m-0 ${className} ${error || fieldError ? "border-red-500" : "focus:border-gray-500 border-[#D5D7DA]"}`}
            placeholder={placeholder}
            style={{
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
              textWrap: isExpanded ? "pretty" : "nowrap",
            }}
            {...rest}
          />
        )}
      />
    </>
  );
}

export default TextAreaComponent;
